var render, staticRenderFns
import script from "./field.table.vue?vue&type=script&lang=js"
export * from "./field.table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a62683c')) {
      api.createRecord('3a62683c', component.options)
    } else {
      api.reload('3a62683c', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/dict/field_extension/field.table.vue"
export default component.exports